export default {"src":"/_next/static/media/ship-schools.285274ad.svg","height":40,"width":80,"blurWidth":0,"blurHeight":0};